import { UseFormRegister, FieldValues } from 'react-hook-form';

import EbookBundleSectionItem, { IPropsEbookBundleItem } from './EbookBundleSectionItem';
import EbookCollectionSectionItem, { IPropsEbookCollectionItem } from './EbookCollectionSectionItem';
import EbookSectionItem, { IPropsEbookItem } from './EbookSectionItem';
import ExploreEbookCollectionSectionItem, { IPropsExploreEbookCollection } from './ExploreEbookCollectionSectionItem';
import ExploreSectionItemV2, { IPropsExploreSectionItemV2 } from './ExploreSectionItemV2';
import FeedSectionItem, { IPropsFeedItem } from './FeedSectionItem';
import LinkSectionItem, { IPropsLinkItem } from './LinkSectionItem';
import PintoCustomLinkSectionItem, { IPropsPintoCustomLinkItem } from './PintoCustomLinkSectionItem';
import ProductSetSectionItem, { IPropsProductSetItem } from './ProductSetSectionItem';
import SearchSectionItem, { IPropsSearchItem } from './SearchSectionItem';
import UserProfileSectionItem, { IPropsUserProfileItem } from './UserProfileSectionItem';

export type DeeplinkSectionItemType =
  | IPropsEbookItem
  | IPropsEbookBundleItem
  | IPropsProductSetItem
  | IPropsLinkItem
  | IPropsSearchItem
  | IPropsExploreSectionItemV2
  | IPropsUserProfileItem
  | IPropsFeedItem
  | IPropsEbookCollectionItem
  | IPropsExploreEbookCollection
  | IPropsPintoCustomLinkItem;

interface IPropsDeeplinkSectionItem {
  index: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemData: any;
  register: UseFormRegister<FieldValues>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const COMPONENT_MAP: Record<string, React.ComponentType<any>> = {
  'ebook-shortcut': EbookSectionItem,
  'ebook-bundle-shortcut': EbookBundleSectionItem,
  'product-set-shortcut': ProductSetSectionItem,
  'link-shortcut': LinkSectionItem,
  'search-shortcut': SearchSectionItem,
  'explore-shortcut': ExploreSectionItemV2,
  'explore-bundle-shortcut': ExploreSectionItemV2,
  'pinto-feed-shortcut': FeedSectionItem,
  'user-profile-shortcut': UserProfileSectionItem,
  'ebook-collection-shortcut': EbookCollectionSectionItem,
  'explore-ebook-collection-shortcut': ExploreEbookCollectionSectionItem,
  'pinto-custom-link': PintoCustomLinkSectionItem,
} as const;

export default function DeeplinkSectionItem(props: IPropsDeeplinkSectionItem) {
  const { index, itemData, register } = props;
  const BaseComponent = COMPONENT_MAP[itemData.type];
  return (
    <div className="border rounded-lg p-0 space-y-4">
      <BaseComponent index={index} itemData={itemData} register={register} isShowOptionalFields={false} expanded />
    </div>
  );
}
